import { IReportedTotalCandidate } from '@common/interfaces/bbc'
import {
  IDifferenceExplanation,
  IExplanationNotKept,
  IReconciliationAcceptancesData,
  IReconciliationReviewData,
} from '@common/interfaces/reconciliation'
import Base, { Wrapped } from './base'

export default class OngoingReporting extends Base {
  list(data: object) {
    return this.apiClient.get('ongoing-reporting', data)
  }

  show(id: string) {
    return this.apiClient.get(`ongoing-reporting/${id}`)
  }

  update(id: string, data: object | FormData) {
    return this.apiClient.put(`ongoing-reporting/${id}`, data)
  }

  submit(id: string, data: object) {
    return this.apiClient.post(`ongoing-reporting/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`ongoing-reporting/${id}`)
  }

  listConsolidated(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/consolidated`, data)
  }

  listConsolidatedMultipleReports(data: object) {
    return this.apiClient.post(`ongoing-reporting/consolidated/multiple-reports`, data)
  }

  listReportedTotalCandidates(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/reported-total-candidates`, data) as Wrapped<
      IReportedTotalCandidate[]
    >
  }

  retryPredictions(id: string, data: object) {
    return this.apiClient.post(`ongoing-reporting/${id}/predictions/retry`, data)
  }

  calculateOngoingReportingFlags(id: string) {
    return this.apiClient.get(`ongoing-reporting/${id}/flags-calculate`)
  }

  updateConsolidated(id: string, data: object) {
    return this.apiClient.put(`ongoing-reporting/${id}/consolidated`, data)
  }

  markAsSeen(id: string, data: object) {
    return this.apiClient.post(`ongoing-reporting/${id}/mark-as-seen`, data)
  }

  listSummary(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/summary`, data)
  }

  listReconciliationReview(id: string, data: object) {
    return this.apiClient.get(
      `ongoing-reporting/${id}/reconciliation-review`,
      data,
    ) as Wrapped<IReconciliationReviewData>
  }

  listReconciliationAcceptances(id: string, data: object) {
    return this.apiClient.get(
      `ongoing-reporting/${id}/reconciliation-acceptances`,
      data,
    ) as Wrapped<IReconciliationAcceptancesData>
  }

  acceptReconciliationDifference(id: string, data: object) {
    return this.apiClient.post(`ongoing-reporting/${id}/reconciliation-acceptances`, data)
  }

  removeReconciliationAcceptance(id: string, data: object) {
    return this.apiClient.delete(`ongoing-reporting/${id}/reconciliation-acceptances`, data)
  }

  explainReconciliationDifference(id: string, data: object) {
    return this.apiClient.post(
      `ongoing-reporting/${id}/reconciliation-review/explanation`,
      data,
    ) as Wrapped<IDifferenceExplanation | IExplanationNotKept | null>
  }

  listInventoryMapping(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/inventory-mapping`, data)
  }

  listSalesBySkuVisualization(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/sales-by-sku-visualization`, data)
  }

  listSalesBySkuFilters(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/sales-by-sku-filters`, data)
  }

  listSalesByDistributionGraph(id: string, data: object) {
    return this.apiClient.get(`ongoing-reporting/${id}/sales-by-distribution-graph`, data)
  }

  updateInventoryMapping(id: string, itemId: string, data: object) {
    return this.apiClient.put(`ongoing-reporting/${id}/inventory-mapping/${itemId}`, data)
  }

  updateReportingStatus(data: object) {
    return this.apiClient.put('ongoing-reporting', data)
  }

  updateAsOfDate(id: string, data: object) {
    return this.apiClient.put(`ongoing-reporting/${id}/as-of-date`, data)
  }
}
